import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './LandingPage.css';
import Header from './landing/Header';
import HeroSection from './landing/HeroSection';
import AboutSection from './landing/AboutSection';
import ServicesSection from './landing/ServicesSection';
import ContactSection from './landing/ContactSection';
import Footer from './landing/Footer';
import ChatWidget from './landing/ChatWidget';
import { useScrollReveal } from '../hooks/useScrollReveal';

function LandingPage() {
  useScrollReveal();
  const location = useLocation();

  // When arriving on the landing page (e.g. from another route), honour the
  // URL hash by scrolling to the target section, otherwise start at the top.
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      // Defer until the sections have rendered.
      requestAnimationFrame(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      });
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location.key, location.hash]);

  return (
    <div className="site">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ContactSection />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}

export default LandingPage;
